module.exports = __webpack_public_path__ + "static/computer-tilt-99bf652b2d384dbdef4b3b4f79c93910.png";